import { useContext } from "react";
import { LanguageContext } from "../languages/languageContext";
import { tutorials } from "../content/tutorials";
import TutorialItem from "./TutorialItem";

const About = () => {
  const language = useContext(LanguageContext).homepage;

  return (
    <section>
      <h2 id="who-am-i">{language.whoami}</h2>
      <p>
        <language.whoami_intro />
      </p>

      <h2 id="who-am-i">{language.tutorials}</h2>

      {tutorials.map((tutorial, idx) => (
        <TutorialItem key={idx} tutorial={tutorial} />
      ))}
    </section>
  );
};

export default About;
